<template lang="pug">
	.creative-debug-info
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :title="$tCaption('Creative debug info')", :autosize="true")
			.content
				.flex-col.space-medium
					.flex-row
						.adt-tab(:class="{ active: tab === 0 }", @click="tab = 0") {{ $tCaption('Description') }}
						.adt-tab(:class="{ active: tab === 1 }", @click="tab = 1") {{ $tCaption('JSON') }}
					pre.pre-wrap(v-if="tab === 0 && description") {{ description }}
					JsonViewer(v-if="tab === 1", :value="info", :expanded="true", :expandDepth="1")
				Loader(v-if="isLoading && tab === 0", :text="$tCaption('Loading', '@actions')", :fullscreen="true")
			template(slot="actions-left")
				DxButton(:text="$tCaption('Copy to clipboard')", icon="fas fa-copy", @click="copy")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import JsonViewer from 'vue-json-viewer';

	export default {
		translationCategory: 'creative.Detail',
		name: 'creative-debug-info',
		components: {
			Loader, Popup, DxButton, JsonViewer
		},
		props: ['creative'],
		data() {
			return {
				isLoading: false,
				popupVisible: false,
				info: null,
				description: null,
				tab: 0,
			};
		},
		computed: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.creativeDebugInfo = this;
		},
		methods: {
			show(info) {
				this.info = info;
				this.popupVisible = false;
				this.$nextTick(() => {
					this.popupVisible = true;
					this.tab = 0;
					this.description = null;
					this.loadInfo();
				});
			},
			async loadInfo() {
				this.isLoading = true;
				try {
					let result = (await this.$Data.postExternalApi('OpenAiGpt3/Run', {
						promptCode: 'EASYCREATIVELOG',
						clientIp: this.$auth.userIP(),
						parameters: {
							JSONRESPONSE: JSON.stringify(this.info)
						}
					}));

					this.description = result?.Data?.Content;
				} finally {
					this.isLoading = false;
				}
			},
			copy() {
				let msg = JSON.stringify(this.info, void 0, '    ');
				if (navigator?.clipboard?.writeText) {
					navigator.clipboard.writeText(msg);
					this.$notifySuccess(this.$tCaption('Data has been copied to clipboard'));
				}
			}
		}
	};
</script>
<style lang='scss'>
	.creative-debug-info {

	}
</style>
